import request from 'utils/request';

export function getRevisions(params = {}, options) {
  const { surveyId } = params;
  const requestOptions = {
    ...options,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
  return request(
    `/api/v3/survey-checkpoints/survey/${surveyId}/get-all`,
    requestOptions,
  );
}

export function deleteQuestionnaireRevision(params = {}, options) {
  const { surveyId, checkpointId } = params;

  const requestOptions = {
    ...options,
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
  return request(
    `/api/v3/survey-checkpoints/survey/${surveyId}/delete/${checkpointId}`,
    requestOptions,
  );
}

export function saveQuestionnaireRevision(params = {}, options) {
  const { surveyId, checkpointName, checkpointDescription } = params;

  const requestOptions = {
    ...options,
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      name: checkpointName,
      description: checkpointDescription,
    }),
  };
  return request(
    `/api/v3/survey-checkpoints/survey/${surveyId}/save-user-checkpoint`,
    requestOptions,
  );
}

export function renameQuestionnaireRevision(params = {}, options) {
  const { surveyId, checkpointName, checkpointDescription, checkpointId } =
    params;

  const requestOptions = {
    ...options,
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      name: checkpointName,
      description: checkpointDescription,
    }),
  };
  return request(
    `/api/v3/survey-checkpoints/survey/${surveyId}/rename/${checkpointId}`,
    requestOptions,
  );
}

export function getQuestionnaireByRevisionId(params = {}, options) {
  const { surveyId, checkpointId } = params;
  const requestOptions = {
    ...options,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
  return request(
    `/api/v3/survey-checkpoints/survey/${surveyId}/get-one/${checkpointId}`,
    requestOptions,
  );
}

export function triggerAutosaveRevision(params = {}, options) {
  const { surveyId } = params;
  const requestOptions = {
    ...options,
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
  return request(
    `/api/v3/survey-checkpoints/survey/${surveyId}/save-auto-checkpoint`,
    requestOptions,
  );
}
